export enum LayingTypeEnum {
  Straight = 0,
  Staggered = 1,
  English = 2,
}
